<script setup lang="ts">
import { UiAutocompleteSelect, UiSelect, UiTextInput } from "@/components"
import type { FieldErrorResolver, SalesOrderFormState } from "./types"
import type { UiOption } from "@/types/ui"

defineProps<{
  formState: SalesOrderFormState
  companyOptions: UiOption[]
  customerOptions: UiOption[]
  fieldError: FieldErrorResolver
}>()

const emit = defineEmits<{
  "company-change": [companyId: number | ""]
  "search-customers": [query: string]
}>()
</script>

<template>
  <section class="rounded-md border border-slate-200 p-4">
    <h2 class="mb-3 text-sm font-semibold text-slate-800">Dados basicos</h2>

    <div class="grid gap-4 md:grid-cols-3">
      <UiSelect
        id="sales-order-company"
        :model-value="formState.company_id"
        label="Empresa"
        :options="companyOptions"
        :error="fieldError('company') || fieldError('company_id')"
        @update:model-value="emit('company-change', ($event as number | ''))"
      />

      <UiAutocompleteSelect
        id="sales-order-customer"
        v-model="formState.customer_id"
        label="Cliente"
        :options="customerOptions"
        :error="fieldError('customer') || fieldError('customer_id')"
        helper-text="Mostra 5 clientes iniciais; continue digitando para buscar mais"
        @search="emit('search-customers', $event)"
      />

      <UiTextInput
        id="sales-order-delivery"
        v-model="formState.delivery_date"
        type="date"
        label="Entrega prevista"
        required
        :error="fieldError('delivery_date')"
      />
    </div>
  </section>
</template>

